module.exports = __webpack_public_path__ + "static/media/techtimeless.5be7db23.png";